import { useAuth0 } from '@auth0/auth0-react';

export type UserTier = 'anonymous' | 'free' | 'pro';

export const useUserTier = (): UserTier => {
  const { isAuthenticated, user } = useAuth0();

  if (!isAuthenticated) {
    return 'anonymous';
  }

  // Check if user has Pro subscription
  // For now, check user metadata or app_metadata
  // In production, this should check against your backend or Auth0 metadata
  const isPro = user?.['https://namin8.com/subscription'] === 'pro' || 
                user?.app_metadata?.subscription === 'pro';

  return isPro ? 'pro' : 'free';
};

